export default {
  headerMenuSocial: '社会责任',
  languageSwitchAria: '切换语言',
  headerLangZh: '中文',
  headerLangEn: 'English'
}



// WEBPACK FOOTER //
// ./src/i18n/locales/zh/common.js